import { AriaPropertyFormatter } from './formatters/log-property-formatter';
import { IDefaultConfig } from '../types';

const propertyFormatter = new AriaPropertyFormatter();

export const defaultConfig: IDefaultConfig = {
  formatters: { propertyFormatter },
  enableSessionTracking: true,
  flushInterval: 5000,
  batchSize: 50,
};
